/**
 * The `source` artwork layer: card illustrations and map tokens cut from
 * assets/source/ships-original.png.
 *
 * In a VITE_SHIP_ART=fallback build vite.config.ts swaps this module for sourceArt.none.ts,
 * so none of these files reach dist/.
 */
import placeholders from '../assets/ships/cards/placeholders.json';

export const available: boolean = true;

export const tokenFiles: Record<string, string> = import.meta.glob<string>('../assets/ships/tokens/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
});

export const cardFiles: Record<string, string> = import.meta.glob<string>(
  '../assets/ships/cards/*.{webp,avif}',
  { eager: true, query: '?url', import: 'default' },
);

export const cardPlaceholders: Record<string, string> = placeholders;
